// import components
import { styled, Box } from '@mui/material';
import TableCRUDLayout, {
  TableCRUDLayoutProps
} from 'components/shared/CRUD/TableCRUDLayout';
import { HierarchyPlanUnit } from './utils/treeHierarchy';

export const StyledLinkPlanUnitFormBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(4, 0)
}));

export const StyledTableBox = styled(Box)(({ theme }) => ({
  height: `calc(100vh - ${theme.spacing(62.5)})`,
  marginTop: theme.spacing(1)
}));

export const StyledTableCRUDLayout = styled(
  TableCRUDLayout as React.ComponentType<
    TableCRUDLayoutProps<HierarchyPlanUnit>
  >
)(({ theme }) => ({
  '& .MuiDataGrid-row:not(.Mui-selected)': {
    '&.highlighted-row': {
      backgroundColor: theme.vars.palette.Alert.warningStandardBg
    }
  }
}));
